import React from 'react';
import { Input } from 'antd';
import * as Styled from './ReactTablePagination.style';
import { PaginationOption } from '../../../views/account/admin/common/types/AccountAdminFormType';

interface IReactTablePaginationProps {
  onChangePaginationOption: (id: keyof PaginationOption, value: number) => void;
  paginationOption: PaginationOption;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  total: number;
}

const ReactTablePagination = (props: IReactTablePaginationProps): JSX.Element => {
  const { onChangePaginationOption, paginationOption, currentPage, setCurrentPage, total = 0 } = props;
  const { pageIndex, pageSize } = paginationOption;

  const pageCount = Math.ceil(total / paginationOption.pageSize) + 1;
  const canPreviousPage = currentPage > 0;
  const canNextPage = currentPage < pageCount - 1;

  return (
    <Styled.Container>
      <Styled.ButtonWrap>
        <button
          onClick={() => {
            setCurrentPage(currentPage - 1);
            onChangePaginationOption('pageIndex', pageIndex - 1);
          }}
          disabled={!canPreviousPage || pageIndex === 1}
        >
          이전
        </button>
      </Styled.ButtonWrap>
      <Styled.Wrapper>
        <Styled.PageInfo>
          페이지
          <Input
            type="number"
            maxLength={pageCount - 1}
            value={currentPage}
            onChange={(e) => {
              const value = parseInt(e.target.value, 10);
              const maxValue = pageCount - 1;
              if (value < 1) {
                setCurrentPage(1);
              } else if (value > maxValue) {
                setCurrentPage(maxValue);
              } else {
                setCurrentPage(value);
              }
            }}
            onKeyUp={(e) => {
              if (e.key === 'Enter') {
                const value = parseInt(e.currentTarget.value, 10);
                onChangePaginationOption('pageIndex', value);
              }
            }}
            style={{ width: '100px' }}
          />
          / <span className="total-page"> {pageCount - 1}</span>
        </Styled.PageInfo>
        <Styled.PageSizeSelect>
          <select
            value={pageSize}
            onChange={(e) => {
              const value = parseInt(e.currentTarget.value, 10);
              setCurrentPage(1);
              onChangePaginationOption('pageSize', value);
            }}
          >
            {[100, 150, 200, 500].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </Styled.PageSizeSelect>
      </Styled.Wrapper>
      <Styled.ButtonWrap>
        <button
          onClick={() => {
            setCurrentPage(currentPage - 1);
            onChangePaginationOption('pageIndex', pageIndex + 1);
          }}
          disabled={!canNextPage}
        >
          다음
        </button>
      </Styled.ButtonWrap>
    </Styled.Container>
  );
};

export default ReactTablePagination;
